export default __webpack_public_path__ + "static/media/logo-digitaly.71258bf8.png";